<template>
  <div class="c-app role-theme-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheHeader nav-role="student_affairs" />
    <div class="c-wrapper">
      <div class="c-body">
        <main class="c-main"><CContainer fluid><router-view /></CContainer></main>
        <TheFooter />
      </div>
    </div>
    <RoleBottomNav role="student_affairs" />
    <FloatingReportFab />
    <CenterLoading />
    <DialogMessage />
  </div>
</template>

<script>
import TheHeader from '@/components/supervisor/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'
import RoleBottomNav from '@/components/common/RoleBottomNav.vue'
import FloatingReportFab from '@/components/common/FloatingReportFab.vue'

export default {
  name: 'StudentAffairsContainer',
  components: { TheHeader, TheFooter, RoleBottomNav, FloatingReportFab },
  mounted() {
    document.body.classList.add('role-unified-theme')
  },
  beforeDestroy() { document.body.classList.remove('role-unified-theme') },
}
</script>

<style scoped>
.c-wrapper { margin-left: 0 !important; }
.c-body { padding-top: 82px !important; }
@media (max-width: 1200px) { .c-main { padding-bottom: 88px; } }
</style>
